export default __webpack_public_path__ + "static/media/pinPlace1.34e3748c.svg";